import { registerPlugin } from '@capacitor/core'

// Debug: Log as early as possible
//console.log('=== AppConfigPlugin.ts LOADING ===')

export interface AppConfigPlugin {
  getConfig(): Promise<{
    API_URL: string
    GOOGLE_MAPS_API_KEY: string
    WEATHER_API_KEY: string | null
    CUSTOMER: string
    TITLE: string
    LOGO: string
    DEFAULT_LOCALE: string
    PRIMARY_COLOR_HEX: string
    PRIMARY_COLOR_RGB: string | number[]
    SECONDARY_COLOR_HEX: string
    SECONDARY_COLOR_RGB: string | number[]
    DANGER_COLOR_HEX: string
    DANGER_COLOR_RGB: string | number[]
    HELP_DOCUMENTS_DOCTYPE: string | null
  }>
}

const AppConfig = registerPlugin<AppConfigPlugin>('AppConfig')

// Debug: verify plugin is registered
/* console.log('AppConfig plugin registered:', AppConfig)
console.log(
  'AppConfig.getConfig exists?',
  typeof AppConfig.getConfig === 'function',
)
if (typeof AppConfig.getConfig === 'function') {
  console.log('AppConfig.getConfig:', AppConfig.getConfig)
} */

export default AppConfig
